// extracted by mini-css-extract-plugin
export default {"h1":"Banner_h1__v+cYA","h3":"Banner_h3__8T9iK","star":"Banner_star__dJsCH","component":"Banner_component__sNEK9","bg":"Banner_bg__iDNBX","p":"Banner_p__gvsu4"};